import React, { ReactNode } from 'react';
import { MonogramPattern } from '../brand/MonogramPattern';
type PageHeroProps = {
  eyebrow: string;
  title: string;
  intro: string;
  children?: ReactNode;
};
export function PageHero({
  eyebrow,
  title,
  intro,
  children
}: PageHeroProps) {
  return <section className="relative overflow-hidden bg-navy" aria-labelledby="page-title" data-id="element-333" data-mp="eou3tcebexp7">
      <MonogramPattern className="pointer-events-none absolute -right-24 top-6 hidden h-[115%] text-gold opacity-[0.16] md:block" data-id="element-334" data-mp="emzgjrfkmthy" />
      <div className="relative mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-335" data-mp="17cycm6s6nqw4">
        <p className="av-enter flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] text-gold" style={{
        animationDelay: '60ms'
      }} data-id="element-336" data-mp="12eellryqfoww">
          <span aria-hidden="true" className="h-px w-6 bg-gold" data-id="element-337" data-mp="xhegpkdmcs7d" />
          {eyebrow}
        </p>
        <h1 id="page-title" className="av-enter mt-6 max-w-3xl font-serif text-[2.75rem] font-medium leading-[1.04] text-white sm:text-6xl lg:text-[4.25rem]" style={{
        animationDelay: '130ms'
      }} data-id="element-338" data-mp="3n2j7gjsrrztu">
          {title}
        </h1>
        <p className="av-enter mt-7 max-w-2xl text-lg leading-relaxed text-white/75" style={{
        animationDelay: '200ms'
      }} data-id="element-339" data-mp="2y1s566duun7f">
          {intro}
        </p>
        {children && <div className="av-enter mt-10" style={{
        animationDelay: '270ms'
      }} data-id="element-340" data-mp="2o3m75zv6617u">
            {children}
          </div>}
      </div>
    </section>;
}